export enum PlatformEventTypeEnum {
    Deposit = 1,
    Play = 21,
    OpenApp = 63
    
    /*
    Fund Transfer = 2,
    Registration = 3,
    Compensation = 4,
    GroupCompensation = 5,
    Grant Following Bonus = 6,
    Followed Delayed Bonus = 7,
    Login = 8,
    UpdateAccountStatus = 9,
    GrantBonus = 10,
    CancelBonus = 11,
    CancelDeposit = 12,
    Cashout = 13,
    CancelCashout = 14,
    UpdateAddress = 15,
    CheckAccountStatus = 16,
    SessionDetails = 17,
    CloseTournaments = 18,
    EnterGame = 19,
    LeaveGame = 20,

    Purchase = 26,
    Invite A Friend = 55,
    Brag = 56,
    Share = 57,
    Got = 58,
    Played total X times = 59,
    Played game X times = 60,
    Player input - Mouse click = 61,
    */
}